import apiFetch from '@wordpress/api-fetch';

export async function getRunState({ packId, moduleId, track = 'quick' } = {}) {
  const params = new URLSearchParams({
    pack_id: String(packId || ''),
    module_id: String(moduleId || ''),
    track: String(track || 'quick'),
  });

  return apiFetch({
    path: `/digivibe-savora/v1/savora/run-state?${params.toString()}`,
    method: 'GET',
  });
}
